export default __webpack_public_path__ + "assets/a47a266e7aebecdea31bc0dc79db379e.png";